module.exports = __webpack_public_path__ + "static/media/Hoddept.d7405162.png";